export default __webpack_public_path__ + "static/media/search-icon.1968d156.svg";